import React from "react";
import { Background, Container, QR, Wrapper } from "./Bottom.style";
export const Bottom = () => {
  const moveKakao = () => {
    window.open("http://pf.kakao.com/_xbIPuG/chat");
  };
  const moveTele = () => {
    window.open("https://t.me/sketchproject_support");
  };
  return (
    <Wrapper>
      <Background></Background>
      <Container.Wrapper>
        <Container.TextWrapper>
          <Container.Title>고객센터</Container.Title>
          <Container.Text>
            <span>고객센터는 채팅 상담으로 운영되며,</span>
            <span> 24시간 이내에 답변을 드리고 있습니다.</span>
          </Container.Text>
        </Container.TextWrapper>
        <QR.Wrapper>
          <QR.Container>
            <QR.Img src="/assets/img/swap_qr_kakao.png" onClick={moveKakao} />
            <QR.Text onClick={moveKakao}>카카오톡</QR.Text>
          </QR.Container>
          <QR.Container>
            <QR.Img src="/assets/img/swap_qr_tele.png" onClick={moveTele} />
            <QR.Text onClick={moveTele}>텔레그램</QR.Text>
          </QR.Container>
        </QR.Wrapper>
      </Container.Wrapper>
    </Wrapper>
  );
};
